import React from "react";
import { ReactComponent as CashIcon } from "assets/img/svg/cash.svg";
import { ReactComponent as ChequeIcon } from "assets/img/svg/cheque.svg";
import { ReactComponent as DDIcon } from "assets/img/svg/dd.svg";
import { ReactComponent as CreditCardIcon } from "assets/img/svg/CreditCard.svg";
import { ReactComponent as DebitCardIcon } from "assets/img/svg/DebitCard.svg";
import { ReactComponent as OnlineIcon } from "assets/img/svg/Online.svg";
import { ReactComponent as OtherIcon } from "assets/img/svg/Other.svg";
import { ReactComponent as Link } from "assets/img/svg/payment-link.svg";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import DefaultView from "./DefaultView";
import ChequeView from "./ChequeView";
import CashView from "./CashView";
import DDView from "./DDView";
import JODOView from "../JodoMode/component/JodoView";
import Loan from "../loan/component/LoanView";
import AxisBank from "../pos/axisBank";
import {isAxisBankEnabled} from  "views/pages/manage/unAssigned/collectPayment/utils.jsx"
import ADBView from "../adbMode/component/ADBView";
import OPModeView from "../OPMode/component/OPModeView";
import AdjustmentView from "./AdsustmentView";
import EFTModeView from "../eftMode/component/EFTView";
import Card from "../cardType/components/Card";
import PineLapUI from "../pos/pinelap/UI";
import PaymentLink from "../paymentLink";
import moment from "moment";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
// import { ReactComponent as JodoIcon } from "assets/img/svg/jodo.svg";
import PRPIcon from "assets/PRP.png";
import BFLIcon from "assets/BFL.png";
import LoanIcon from "assets/Loan.png";
import JodoIcon from "assets/JODO.png";
import QRCView from "./QRCView";
import LinkView from "../paymentLink/LinkView";
export const defaultColorStyle = {
  color: "#FFF",
  textAlign: "center",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "24px" /* 200% */,
  backgroundColor: "#08767E",
  padding: "4px",
};

export const modes = [
  { icon: <CashIcon />, text: "Cash", key: "Cash" },
  { icon: <ChequeIcon />, text: "Cheque/DD", key: "chequeDD" },
  { icon: <CreditCardIcon />, text: "Card", key: "cards" },
  // { icon: <DebitCardIcon />, text: 'Debit Card', key: 'DB' },
  { icon: <OnlineIcon />, text: "Online", key: "OP" },
  { icon: <img src={LoanIcon} />, text: "Loan", key: "loans" },
  { icon: <Link />, text: "Link", key: "Link" },
  { icon: <OtherIcon />, text: "Other", key: "others" },
];
const commonModes = {
  cards: [
    { icon: <DebitCardIcon />, text: "Debit Card", key: "DB" },
    { icon: <CreditCardIcon />, text: "Credit Card", key: "CC" },
  ],
  chequeDD: [
    { icon: <ChequeIcon />, text: "Cheque", key: "CHKL" },
    { icon: <DDIcon />, text: "DD", key: "DD" },
  ],
  others: [
    { icon: "", text: "ADB", key: "ADB" },
    { icon: "", text: "EFT", key: "EFT" },
    { icon: "", text: "JODO", key: "JODO" },
    { icon: "", text: "ADJ", key: "ADJ" },
    { icon: "", text: "CMP", key: "CMP" },
    { icon: "", text: "SDJ", key: "SDJ" },
    { icon: "", text: "QRC", key: "QRC" },
    { icon: "", text: "MPOS", key: "MPOS" },
    { icon: "", text: "AXSB", key: "AXSB" },
  ],
};

export const subModes = {
  ...commonModes,
  loans: [
    {
      icon: <img src={BFLIcon} />,
      text: "Bajaj finserv ltd (BFL)",
      key: "BFL",
    },
    { icon: <img src={PRPIcon} />, text: "Propelled (PRP)", key: "PRP" },
    {
      icon: <span style={defaultColorStyle}>ED</span>,
      text: "Eduvance (EDV)",
      key: "EDV",
    },
    {
      icon: <span style={defaultColorStyle}>GQC</span>,
      text: "Gray Quest (GQC)",
      key: "GQC",
    },
    {
      icon: <span style={defaultColorStyle}>JEMI</span>,
      text: "JODO EMI (JEMI)",
      key: "JEMI",
    },
    // { icon: <img src={JodoIcon} />, text: 'JODO EMI (JEMI)', key: 'JODO' },
  ],
};

export const paymentModeWithOutLoan = {
  ...commonModes,
};

export const labelSyle = {
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "16px",
  color: "#262626",
};
export const customStyle = {
  left: "8px",
  display: "block",
  top: "11px",
};
export const inputAmountStyle = {
  height: "47px",
  width: "265px",
  borderRadius: "5px",
  paddingLeft: "20px",
};

export const getDropdowns = async () => {
  const resp = await fetchAllPostPromisedData(
    `${endpoint.bankMaster.search}?offset=${-1}`,
    { status: "ACTIVE" },
    "post"
  );
  if (resp?.code === 200) {
    return resp.data?.bankMasterList?.map((item) => {
      return { label: item?.bankName, value: item?.bankId, id: item?.id };
    });
  }
};

export const paymentMode = {
  default: (props) => <DefaultView {...props} />,
  cash: (props) => <CashView {...props} />,
  Link: (props) => <PaymentLink {...props} />,
  LINK: (props) => <LinkView {...props} />,
  cheque: (props) => <ChequeView {...props} />,
  dd: (props) => <DDView {...props} />,
  creditCard: (props) => {
    if (props?.contextValue?.isOnlineModeEnabled)
      return <PineLapUI heading={"Credit Card"} {...props}></PineLapUI>;
    return <Card heading={"Credit Card"} {...props} />;
  },
  debitCard: (props) => {
    if (props?.contextValue?.isOnlineModeEnabled)
      return <PineLapUI heading={"Debit Card"} {...props}></PineLapUI>;
    return <Card heading={"Debit Card"} {...props} />;
  },
  online: (props) => <OPModeView {...props} />,
  loanBFL: (props) => (
    <Loan heading={"Loan - Bajaj Finserv Ltd (BFL)"} {...props} />
  ),
  loanPRP: (props) => <Loan heading={"Loan - PRP"} {...props} />,
  loanEDV: (props) => <Loan heading={"Loan - EDV"} {...props} />,
  eft: (props) => <EFTModeView {...props} />,
  jodo: (props) => <JODOView {...props} />,
  adb: (props) => <ADBView {...props} />,
  adj: (props) => (
    <AdjustmentView heading="Adjustment Payment (ADJ)" {...props} />
  ),
  cmp: (props) => <AdjustmentView heading="CMPR" {...props} />,
  sdj: (props) => (
    <AdjustmentView heading="Security Deposit Adjustment (SDJ)" {...props} />
  ),
  qrc: (props) => <QRCView heading="" {...props} />,
  mpos: (props) => <Card heading="MPOS" {...props} />,
  gqc: (props) => <Loan heading={"GQC"} {...props} />,
  jemi: (props) => <Loan heading={"JEMI"} {...props} />,
  AXSB: (props) =>{
    console.log(props?.contextValue, "contextValue")
      if(isAxisBankEnabled(props?.contextValue?.availablePosList))
     return  <AxisBank heading={"AXSB(Axis Sound Box)"} {...props} />
   return <Card heading={"AXSB(Axis Sound Box)"} {...props} />
}
}

export const getPaymentModeName = (key) => {
  if (key?.toUpperCase() == "CASH") return "Cash";
  const paymentMode = [...modes]?.find(
    (mode) => mode?.key?.toUpperCase() === key?.toUpperCase()
  );
  const subModeKeyList = Object.values(subModes);
  const dispValue = paymentMode
    ? paymentMode.text
    : subModeKeyList.reduce((found, item) => {
        if (found) return found;
        const obj = item.find((mode) => mode?.key === key);
        return obj || found;
      }, null)?.text;
  return dispValue;
};

export const initialForm = {
  paymentMode: "",
  paymentModeId: "",
  voucherId: null,
  referenceNumber: "",
  bankMasterId: "",
  doId: null,
  paymentModeDescription: null,
  voucherUTRKey: null,
  paymentModeDate: "",
  bank: "",
  paymentModeAttachmentS3Key: "",
  gatewayName: null,
  cardType: null,
  firstName: null,
  LastName: null,
  onlineSale: null,
};

export const getSwapLabelValue = (dropdown) => {
  return dropdown.map((item) => ({
    id: item?.id,
    label: item?.value,
    value: item?.label,
  }));
};

export const paymentModeMapping = {
  cash: "Cash",
  creditCard: "CC",
  online: "OP",
  cheque: "CHKL",
  adb: "ADB",
  eft: "EFT",
  jodo: "JODO",
  adj: "ADJ",
  cmp: "CMP",
  sdj: "SDJ",
  debitCard: "DB",
  dd: "DD",
  loanEDV: "EDV",
  loanPRP: "PRP",
  loanBFL: "BFL",
  cmp: "CMP",
  qrc: "QRC",
  Link: "Link",
  mpos: "MPOS",
  gqc: "GQC",
  jemi: "JEMI",
  AXSB: "AXSB",

};

export const findPaymentModeKey = (value) => {
  if (value.toUpperCase() === "CASH") {
    return "cash";
  }
  return Object.keys(paymentModeMapping).find(
    (key) => paymentModeMapping[key] === value
  );
};

export const getBalanceAmount = (
  paidAmount,
  balanceAmount,
  setBalanceAmount,
  setBalanceMode,
  isVoucher
) => {
  if (paidAmount <= balanceAmount) {
    setBalanceAmount((prev) => prev - paidAmount);
    isVoucher ? setBalanceMode(false) : setBalanceMode(true);
  } else {
    setBalanceAmount(0);
    setBalanceMode(false);
  }
};

export const validatePaymentMode = async (
  studentBasicDetails,
  currentPaymentMode,
  paymentModeForm,
  selectedChargesAmount,
  bankMasterId,
  voucher = "",
  setBalanceAmount,
  setBalanceMode,
  setloader,
  setCollectPayment,
  balanceAmount,
  collectPayment,
  bypassValidation
) => {
  const url = `${endpoint.paymentCollection.validatePaymentMode}`;
  const isNotVoucher = Object.keys(voucher).length === 0;
  const isPHXVoucher = voucher?.voucherType === "PHX";
  const request = {
    applicationId: studentBasicDetails?.applicationId,
    opportunityOwnerId: studentBasicDetails?.opportunityOwnerId,
    psid: studentBasicDetails?.psid,
    businessAreaId: studentBasicDetails?.buId,
    businessAreaDispValue:
      studentBasicDetails?.businessArea ?? studentBasicDetails?.bu,
    term: studentBasicDetails?.term,
    courseId: studentBasicDetails?.courseId,
    applicationQuotationId: studentBasicDetails?.applicationQuotationId,
    totalAmountSelected:
      studentBasicDetails?.totalPaidAmount ?? selectedChargesAmount,
    securityConfigItemType: studentBasicDetails?.securityConfigItemType,
    ...(!isPHXVoucher && {
      paymentModeCollectionRequestList: [
        {
          paymentMode: isNotVoucher
            ? paymentModeMapping[currentPaymentMode] == "Cash"
              ? "CASH"
              : paymentModeMapping[currentPaymentMode] ?? currentPaymentMode
            : voucher?.type,
          paymentModeId:
            bankMasterId[paymentModeMapping[currentPaymentMode]] ??
            bankMasterId[currentPaymentMode] ??
            bankMasterId[voucher?.type],
          paidAmount: !isNotVoucher
            ? voucher?.appliedVoucherAmount
            : paymentModeForm?.paidAmount,
          voucherUTRKey: voucher?.voucherId ?? paymentModeForm?.voucherUTRKey,
          referenceNumber: !isNotVoucher
            ? voucher?.description
            : paymentModeForm?.referenceNumber?.label
            ? paymentModeForm?.referenceNumber?.label
            : paymentModeForm?.referenceNumber,
          bankMasterId: isNotVoucher ? paymentModeForm?.bank?.id : null,
          paymentModeDescription: isNotVoucher
            ? paymentModeForm?.paymentModeDescription
            : null,
          paymentModeDate: !isNotVoucher
            ? voucher?.transactionDateAndTime
              ? moment(voucher?.transactionDateAndTime).format("YYYY-MM-DD")
              : null
            : !paymentModeForm?.paymentModeDate
            ? moment(new Date()).format("YYYY-MM-DD")
            : moment(paymentModeForm?.paymentModeDate).format("YYYY-MM-DD"),
          bankName: isNotVoucher
            ? paymentModeMapping[currentPaymentMode] == "EFT"
              ? paymentModeForm?.bank?.label
              : paymentModeForm?.bank?.value
            : voucher?.bankName,
          paymentModeAttachmentS3Key: isNotVoucher
            ? paymentModeForm?.paymentModeAttachmentS3Key
            : null,
          gatewayName: isNotVoucher ? paymentModeForm?.gatewayName : null,
          cardType: isNotVoucher
            ? paymentModeForm?.cardType?.label
            : voucher?.cardType,
          firstName: isNotVoucher
            ? paymentModeForm?.firstName
            : voucher?.firstName,
          lastName: isNotVoucher
            ? paymentModeForm?.lastName
            : voucher?.lastName,
          onlineSale: isNotVoucher
            ? paymentModeForm?.onlineSale?.label
            : voucher?.onlineSale,
          fileName: paymentModeForm?.fileName,
          paymentModeApprovalDetailslDto: studentBasicDetails?.receiptId
            ? {
                oldReferenceNumber: studentBasicDetails?.oldReferenceNumber,
                pserpReceiptId: studentBasicDetails?.receiptId,
                oldPaymentMode: studentBasicDetails?.oldPaymentMode,
              }
            : null,
        },
      ],
    }),
    ...(isPHXVoucher && {
      paymentVoucherDtoList: [
        { id: voucher?.vId, paidAmount: voucher?.appliedVoucherAmount },
      ],
    }),
  };

  const updatePaymentDetails = () => {
    setCollectPayment((prev) =>
      //   let tempCollectPayment = [...prev];
      //   tempCollectPayment[paymentModeForm?.indexToEdit] =
      //     paymentModeForm?.referenceNumber
      //     ?{...request?.paymentModeCollectionRequestList[0],referenceNumber:paymentModeForm?.referenceNumber}
      //     :request?.paymentModeCollectionRequestList[0];
      //   return tempCollectPayment;
      // });

      insertElementAtIndex(
        prev,
        paymentModeForm?.referenceNumber
          ? {
              ...request?.paymentModeCollectionRequestList[0],
              referenceNumber: paymentModeForm?.referenceNumber,
            }
          : request?.paymentModeCollectionRequestList[0],
        paymentModeForm?.indexToEdit
      )
    );
  };

  try {
    setloader(true);
    // debugger
    let response;
    if (!bypassValidation)
      response = await fetchAllPostPromisedData(url, request, "post");
    if (bypassValidation || response?.code === 200) {
      setloader(false);
      voucher == "" &&
        getBalanceAmount(
          paymentModeForm?.paidAmount,
          balanceAmount,
          setBalanceAmount,
          setBalanceMode
        );
      paymentModeForm?.indexToEdit || paymentModeForm?.indexToEdit === 0
        ? updatePaymentDetails()
        : isNotVoucher &&
          (request?.paymentModeCollectionRequestList[0]?.referenceNumber
            ? paymentModeForm?.referenceNumber?.value
              ? setCollectPayment((prev) => [
                  ...prev,
                  {
                    ...request?.paymentModeCollectionRequestList[0],
                    referenceNumber: paymentModeForm?.referenceNumber,
                  },
                ])
              : setCollectPayment((prev) => [
                  ...prev,
                  request?.paymentModeCollectionRequestList[0],
                ])
            : updatePaidAmount(
                setCollectPayment,
                collectPayment,
                request?.paymentModeCollectionRequestList[0]
              ));
      return true;
    } else {
      //failureToast(response?.message);

      setloader(false);
      return false;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updatePaidAmount = (
  setCollectPayment,
  collectPayment,
  requestList
) => {
  let flag = 0;
  const updatedCollectPaymentList = collectPayment.map((item) => {
    if (item?.paymentMode == requestList?.paymentMode) {
      flag = 1;
      return {
        ...item,
        paidAmount: Number(item?.paidAmount) + Number(requestList?.paidAmount),
      };
    } else {
      return item;
    }
  });
  flag
    ? setCollectPayment(updatedCollectPaymentList)
    : setCollectPayment([...collectPayment, requestList]);
};

export const getKeyByValue = (object, value) => {
  const ans = Object.keys(object).find((key) => object[key] === value);
  return ans;
};

export const setUpdatedAdjustmentAmount = (
  collectPayment,
  currentPayModeType,
  maxAvailableAmount = 0
) => {
  const paymentObj = collectPayment.find(
    (item) => item?.paymentMode === currentPayModeType
  );
  return paymentObj?.paidAmount
    ? Number(maxAvailableAmount) - Number(paymentObj?.paidAmount)
    : Number(maxAvailableAmount);
};

export const numberDecimalLimitRegex = (maxIntegerLength, maxDecimalLength) => {
  return new RegExp(
    `^\\d{0,${maxIntegerLength}}(\\.\\d{0,${maxDecimalLength}})?$`
  );
};

export const getSumOfAllPaymentMode = async (psid, mode) => {
  const url = endpoint?.manageReceipts?.amount;
  const request = {
    psid,
    paymentMethods: [mode],
  };
  const res = await fetchAllPostPromisedData(url, request, "post");
  if (res?.code === 200) {
    return res?.data[0]?.amount;
  }
};

export const getPaidCash = (collectPayment) => {
  const paymentObj = collectPayment.find(
    (item) => item?.paymentMode === "CASH"
  );
  return paymentObj?.paidAmount ? Number(paymentObj?.paidAmount) : 0;
};

export const insertElementAtIndex = (arr, el, index) => {
  const tempArr = [...arr];
  tempArr.splice(index, 0, el);
  return tempArr;
};

export const getPaymentModeDispValue = (paymentMode) =>
  paymentMode?.paymentModeDesc ||
  getPaymentModeName(paymentMode?.paymentMode) ||
  paymentMode?.paymentMode;

export const statusStyle = {
  Failed: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Success: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Pending: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  'In Progress':{
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  }
};

export const getPdcCost = async (
  chargeDetailsType = "PDC_CHARGE",
  studentBasicDetails
) => {
  const { psid, applicationId, buId } = studentBasicDetails;
  const request = {
    chargeDetailsType,
    psid,
    applicationId,
    businessAreaId: buId,
  };
  const url = endpoint?.paymentCollection?.chargeDetail;
  const res = await fetchAllPostPromisedData(url, request);
  if (res?.code == 200) return res?.data?.applicationOtherChargesDetailsDTO;
};
export const bankNameRequiredPayModeList = ["CHKL", "DD", "CC", "OP", "MPOS"];
